
import Modal from 'react-bootstrap/Modal';
import TextInputClearable from './text-input-clearable';
import { useEffect, useState } from 'react';
import { StepperField, ToggleButton, Button } from '@aws-amplify/ui-react';
import { Label, Input, Flex } from '@aws-amplify/ui-react';
const EditResult = (props) => {

    const [comment, setComment] = useState(props.selecteditem?.comment || "")
    const [repetitions, setRepetitions] = useState(props.selecteditem?.repetitions || 6)
    const [weight, setWeight] = useState(props.selecteditem?.result || 50)
    const [step, setStep] = useState(5)
    const [date, setDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0]; // YYYY-MM-DD format
    });

    useEffect(() => {
        setComment(props.selecteditem?.comment || "")
        setRepetitions(props.selecteditem?.repetitions || 6)
        setWeight(props.selecteditem?.result || 50)
        if (props.selecteditem?.timestamp)
            setDate(new Date(props.selecteditem.timestamp).toISOString().split('T')[0])
        else
            setDate((new Date()).toISOString().split('T')[0])

    }, [props.selecteditem])

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Add New Result
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Flex direction="column" gap="small" className='m-1'>
                    <Label htmlFor="departing">Date</Label>
                    <Input
                        id="departing"
                        type="date"
                        value={date}
                        onChange={e => setDate(e.target.value)}
                    />
                </Flex>
                <div className='mx-1'>
                    <TextInputClearable
                        controlId="comment"
                        label="Comment"
                        value={comment}
                        onValueChanged={(e) => { setComment(e) }}
                        placeholder="Comment"
                        maxLength={128}
                    >

                    </TextInputClearable>
                </div>
                <div className='d-flex align-items-end justify-content-between'>
                    <StepperField
                        className='m-1 flex-grow-1'
                        min={1}
                        max={100}
                        step={1}
                        size="small"
                        value={repetitions}
                        onStepChange={(e) => setRepetitions(e)}
                        label="Repetitions"
                    />
                    <div className='d-flex align-items-end'>
                        <StepperField
                            className='m-1'
                            min={0}
                            max={500}
                            step={step}
                            size="small"
                            value={weight}
                            onStepChange={(e) => {

                                setWeight(e)
                            }
                            }
                            label="Weight"
                        />
                        <div className='d-flex align-items-end'>
                            <ToggleButton
                                variation="primary"
                                isPressed={step === 2.5}
                                onChange={() => { setStep(2.5) }}
                                size="small" className='m-1'>
                                2.5
                            </ToggleButton>
                            <ToggleButton variation="primary" size="small" className='m-1'
                                isPressed={step === 5}
                                onChange={() => { setStep(5) }}>
                                5
                            </ToggleButton>
                            <ToggleButton variation="primary" size="small" className='m-1'
                                isPressed={step === 10}
                                onChange={() => { setStep(10) }}>
                                10
                            </ToggleButton>
                            <ToggleButton variation="primary" size="small" className='m-1'
                                isPressed={step === 15}
                                onChange={() => { setStep(15) }}>
                                15
                            </ToggleButton>
                            <ToggleButton variation="primary" size="small" className='m-1'
                                isPressed={step === 25}
                                onChange={() => { setStep(25) }}>
                                25
                            </ToggleButton>
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button
                    variation='primary'
                    onClick={() => {
                        props.onHide({
                            id: props.selecteditem?.id,
                            comment: comment,
                            deleted: false,
                            modified: Date.now(),
                            repetitions: repetitions,
                            result: weight,
                            timestamp: new Date(date).getTime(),
                        })
                    }}>Save</Button>
            </Modal.Footer>
        </Modal >
    );
}

export default EditResult